import { QueryClient } from "@tanstack/react-query";

/**
 * The app QueryClient with the defaults: refetch on focus (replaces the MVP's hand-rolled
 * visibilitychange polls) and always on reconnect (the unconditional catch-up refetch, GATE-4). Per-domain
 * staleTime is set on the individual wrapper hooks, not globally.
 */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: true,
        refetchOnReconnect: "always",
        retry: 1,
        staleTime: 30_000,
      },
    },
  });
}
